export default "__VITE_ASSET__IHBmXl3k__"